import { observable, action } from 'mobx';
class AllScreen {
    @observable public allScreenReport: ReportData | null = null;
    @action
    public changeAllScreenReport = (allScreenReport: ReportData) => {
        this.allScreenReport = allScreenReport;
    }
}
export { AllScreen }
export default new AllScreen();